import script from "./digitalmanEffect.vue?vue&type=script&lang=ts&setup=true"
export * from "./digitalmanEffect.vue?vue&type=script&lang=ts&setup=true"

import "./digitalmanEffect.vue?vue&type=style&index=0&id=753f8293&lang=scss&scoped=true"
import "./digitalmanEffect.vue?vue&type=style&index=1&id=753f8293&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-753f8293"]])

export default __exports__